import React, { useState, useEffect, forwardRef } from "react";
import "./CodeHistory.css";
import { useSelector, useDispatch } from "react-redux";
import FileIcon from "../../../common/assets/images/filefolder.png";
import {
  clearCodePathHistory,
  restoreToPathwayStep,
} from "../CodeSearch/redux/codeSearchSlice";

const CodeHistory = () => {
  const dispatch = useDispatch();
   const codePathHistory = useSelector((s) => s.codeSearch.codePathHistory);
  const pathwaySnapshots = useSelector((s) => s.codeSearch.pathwaySnapshots);
  const showFinalScreen = useSelector(
    (state) => state.codeSearch.finalShowScreen
  );
  // Log codePathHistory updates in CodeHistory
  // useEffect(() => {
  //   console.log("CodeHistory received codePathHistory:", JSON.stringify(codePathHistory, null, 2));
  // }, [codePathHistory]);

  const handleClearHistory = () => {
    dispatch(clearCodePathHistory());
  };
  

  // Initialize dropdown states for each tree (open first tree by default)
  const initialDropdownStates = codePathHistory.reduce((acc, _, index) => {
    acc[index] = true; // Open first tree, close others
    return acc;
  }, {});
  useEffect(() => {
    const updatedDropdownStates = codePathHistory.reduce((acc, _, index) => {
      acc[index] =
        dropdownStates[index] !== undefined ? dropdownStates[index] : true;
      return acc;
    }, {});
    setDropdownStates(updatedDropdownStates);
  }, [codePathHistory]);

  const [dropdownStates, setDropdownStates] = useState(initialDropdownStates);

  const toggleDropdown = (index) => {
    setDropdownStates({
      ...dropdownStates,
      [index]: !dropdownStates[index],
    });
  };
  // Replace category names
  const getCategoryDisplay = (category) => {
    if (category === "Additional Diagnoses") return "ICD-10-AM Diagnosis Codes";
    if (category === "Procedure Codes") return "ACHI Codes";
    return category;
  };
  // Recursive function to render nodes
  const renderNode = (node, depth = 0) => {
      if (
    !node ||
    node.description === "" ||
    node.description === "No or already coded"
  )
    return null; //Skip this node completely
    const indentStyle = { marginLeft: `${depth * 1}px` };
  // const handleRestoreClick = (timestamp) => {
  //   const snapshot = pathwaySnapshots[timestamp];
  //   if (!snapshot) return;

  //   // 1. Truncate + restore in Redux (as before)
  //   dispatch(restoreToPathwayStep(timestamp));

  //   // 2. CRITICAL FIX: sync the native browser history stack
  //   //    so the very next window.history.back() reveals THIS state,
  //   //    not a stale entry from the abandoned branch.
  //   window.history.pushState(snapshot, "", window.location.pathname);
  // };
    const handleRestoreClick = (timestamp) => {
      const snapshot = pathwaySnapshots[timestamp];
      if (!snapshot) return;

      const currentDepth = window.history.state?._historyDepth || 0;
      const targetDepth = snapshot._historyDepth || 0;
      const delta = currentDepth - targetDepth;

      dispatch(restoreToPathwayStep(timestamp));

      if (delta > 0) {
        window.__suppressPop = true; // NEW — tell CodeSearch's popstate listener to ignore this jump
        const onceBack = () => {
          window.removeEventListener("popstate", onceBack);
          window.history.replaceState(snapshot, "", window.location.pathname);
          window.__suppressPop = false;
        };
        window.addEventListener("popstate", onceBack);
        window.history.go(-delta); // pop the stale branch instead of stacking on top of it
      } else {
        window.history.replaceState(snapshot, "", window.location.pathname);
      }
    };
      // NEW — only style/behave as a link if a snapshot actually exists for this node
      const currentNodeTimestamp =
  codePathHistory[codePathHistory.length - 1]?.timestamp;
  const isCurrentNode = node.timestamp === currentNodeTimestamp;

const isClickable =
  !isCurrentNode && Boolean(pathwaySnapshots[node.timestamp]);
    return (
      <div key={node.timestamp} className="history-item-wrapper" 
        onClick={() => handleRestoreClick(node.timestamp)}
         role={isClickable ? "button" : undefined}
         style={isClickable ? {cursor: "pointer", color: "#1a73e8", textDecoration: "underline" } :{}}>
        <div className="history-item-content" style={indentStyle}>
          <span className="history-item-icon">
            <img src={FileIcon} alt="folder" />
          </span>
          <div>
            {/* Always show category */}
            {node.category !== null &&
              !(
                typeof node.description === "string" &&
                node.description.endsWith("-")
              ) && (
                <p className="history-item-category">
                  {getCategoryDisplay(node.category)}
                </p>
              )}

            {/* If final screen, show name + description, else just name */}
            <p className="history-item-code">
              {node.category &&
              !node.isFromTabular &&
              !(
                typeof node.description === "string" &&
                node.description.endsWith("-") 
              ) ? (
                <>
                  {/* show code-description only if they are different */}
                  {node.code}
                  {node.description && node.description !== node.code
                    ? `-${node.description}`
                    : ""}
                </>
              ) : node?.isFromTabular && node.category ? (
                <>
                  {/* show description - code, but avoid duplicate if same */}
                  {node.description && node.description !== node.code
                    ? `${node.description} - `
                    : ""}
                  {node.code}
                </>
              ) : (
               
                node.isFromTabular ? node.description:node.code
              )}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="history-container">
      {codePathHistory.map((tree, index) => (
        <div key={index} className="history-dropdown-container">
          {renderNode(tree, 0, index)}
        </div>
      ))}
    </div>
  );
};

export default CodeHistory;
